export default class FileDownload {
	#$q;

	/**
	 * Instantiates a FileDownload
	 *
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {any} [item]
	 */
	/* @ngInject */
	constructor($injector, item = null) {
		this.#$q = $injector.get('$q');

		this.abort = false;
		this.compressing = false;
		this.downloaded = 0;
		this.error = null;
		this.kid = item ? item.kid : null;
		this.name = item ? item.name : null;
		this.packetnb = null;
		this.packetsize = null;
		this.parts = [];
		this.progress = 0;
		this.promiseTimeout = $injector.get('$q').defer();
		this.size = item?.file_size;
		this.type = item?.mimetype;
	}

	/**
	 * Abort the current packet downloading
	 * (this will resolve the promise in $http AngularJS request)
	 */
	cancel() {
		this.abort = true;
		this.error = 'abort';
		this.promiseTimeout.resolve(this.error);
	}
}
